import React from "react";
import { createBrowserRouter } from "react-router-dom";
import OrderCandidatePage from "pages/OrdersView/OrderCandidatePage/OrderCandidatePage";
import OrderStatusPage from "pages/OrdersView/OrderStatusPage/OrderStatusPage";
import ClientDashboardPage from "pages/ClientView/ClientDashboardPage/ClientDashboardPage";
import ClientAnalyticsPage from "pages/ClientView/ClientAnalyticsPage/ClientAnalyticsPage";
import ClientSettingsPage from "pages/ClientView/ClientSettingsPage/ClientSettingsPage";
import OrderAnalyticsPage from "pages/OrdersView/OrderAnalyticsPage/OrderAnalyticsPage";
import OrderJobPostingPage from "pages/OrdersView/OrderJobPostingPage/OrderJobPostingPage";
import OrderSettingsPage from "pages/OrdersView/OrderSettingsPage/OrderSettingsPage";
import OrderDashboardPage from "pages/OrdersView/OrderDashboardPage/OrderDashboardPage";
import PricingPage from "pages/PublicView/PricingPage/PricingPage";
import AboutPage from "pages/PublicView/AboutPage/AboutPage";
import ReviewsPage from "pages/PublicView/ReviewsPage/ReviewsPage";
import LoginPage from "pages/PublicView/LoginPage/LoginPage";
import SignupPage from "pages/PublicView/SignupPage/SignupPage";
import ForgotPasswordPage from "pages/PublicView/ForgotPasswordPage/ForgotPasswordPage";
import ResetPasswordPage from "pages/PublicView/ResetPasswordPage/ResetPasswordPage";
import LegalPage from "pages/PublicView/LegalPage/LegalPage";
import TermsofUsePage from "pages/PublicView/TermsofUsePage/TermsofUsePage";
import PrivacyPolicyPage from "pages/PublicView/PrivacyPolicyPage/PrivacyPolicyPage";
import CommunityGroupsPage from "pages/PublicView/CommunityGroupsPage/CommunityGroupsPage";
import ProductRoadmapPage from "pages/PublicView/ProductRoadmapPage/ProductRoadmapPage";
import SuggestFeaturePage from "pages/PublicView/SuggestFeaturePage/SuggestFeaturePage";
import ContactUsPage from "pages/PublicView/ContactUsPage/ContactUsPage";
import RootSwitch from "components/switches/RootSwitch";
import UnauthenticatedUserFilter from "components/filters/UnauthenticatedUserFilter";
import AuthenticatedUserFilter from "components/filters/AuthenticatedUserFilter";
import PublicUserFilter from "components/filters/PublicUserFilter";
import CommunityFacebookPage from "pages/PublicView/CommunityFacebookPage/CommunityFacebookPage";
import CommunityDiscordPage from "pages/PublicView/CommunityDiscordPage/CommunityDiscordPage";
import CommunityLinkedinPage from "pages/PublicView/CommunityLinkedinPage/CommunityLinkedinPage";
import OrderShortlistPage from "pages/OrdersView/OrderShortlistPage/OrderShortlistPage";
import OrderNotificationsPage from "pages/OrdersView/OrderNotificationsPage/OrderNotificationsPage";
import ClientNotificationsPage from "pages/ClientView/ClientNotificationsPage/ClientNotificationsPage";
import RecruiterDashboardPage from "pages/RecruitersView/RecruiterDashboardPage/RecruiterDashboardPage";
import RecruiterAnalyticsPage from "pages/RecruitersView/RecruiterAnalyticsPage/RecruiterAnalyticsPage";
import RecruiterClientsPage from "pages/RecruitersView/RecruiterClientsPage/RecruiterClientsPage";
import RecruiterNotificationsPage from "pages/RecruitersView/RecruiterNotificationsPage/RecruiterNotificationsPage";
import RecruiterOrdersPage from "pages/RecruitersView/RecruiterOrdersPage/RecruiterOrdersPage";
import RecruiterSettingsPage from "pages/RecruitersView/RecruiterSettingsPage/RecruiterSettingsPage";
import RecruiterSettingsIntegrationsPage from "pages/RecruitersView/RecruiterSettingsIntegrationsPage/RecruiterSettingsIntegrationsPage";
import RecruiterSettingsProfilePage from "pages/RecruitersView/RecruiterSettingsProfilePage/RecruiterSettingsProfilePage";
import RecruiterSettingsSubscriptionPage from "pages/RecruitersView/RecruiterSettingsSubscriptionPage/RecruiterSettingsSubscriptionPage";
import RecruiterSettingsWorkspacePage from "pages/RecruitersView/RecruiterSettingsWorkspacePage/RecruiterSettingsWorkspacePage";
import AdminRecruitersPage from "pages/AdminView/AdminRecruitersPage/AdminRecruitersPage";
import AdminSupportPage from "pages/AdminView/AdminSupportPage/AdminSupportPage";
import AnalyticsSwitch from "components/switches/AnalyticsSwitch";
import ClientsSwitch from "components/switches/ClientsSwitch";
import NotificationsSwitch from "components/switches/NotificationsSwitch";
import OrdersSwitch from "components/switches/OrdersSwitch";
import SettingsSwitch from "components/switches/SettingsSwitch";
import SettingsProfileSwitch from "components/switches/SettingsProfileSwitch";
import SettingsWorkspaceSwitch from "components/switches/SettingsWorkspaceSwitch";
import BlogPage from "pages/PublicView/BlogPage/BlogPage";
import CustomerSupportPage from "pages/PublicView/CustomerSupportPage/CustomerSupportPage";
import LiveChatPage from "pages/PublicView/LiveChatPage/LiveChatPage";
import CreateOrderSwitch from "components/switches/CreateOrderSwitch";
import ClientOrdersPage from "pages/ClientView/ClientOrdersPage/ClientOrdersPage";
import RecruiterCreateOrderPage from "pages/RecruitersView/CreateOrderPage/RecruiterCreateOrderPage";
import PublicEmployerFilter from "components/filters/PublicEmployerFilter";
import CreateClientSwitch from "components/switches/CreateClientSwitch";
import RecruiterCreateClientPage from "pages/RecruitersView/RecruiterCreateClientPage/RecruiterCreateClientPage";
import ClientCreateOrderPage from "pages/ClientView/ClientCreateOrderPage/ClientCreateOrderPage";

export const appRouter = createBrowserRouter([
  {
    path: "/",
    element: <RootSwitch />,
  },
  {
    path: "/",
    element: <UnauthenticatedUserFilter />,
    children: [
      {
        path: "login",
        element: <LoginPage />,
      },
      {
        path: "signup",
        element: <SignupPage />,
      },
      {
        path: "forgot-password",
        element: <ForgotPasswordPage />,
      },
      {
        path: "reset-password",
        element: <ResetPasswordPage />,
      },
    ],
  },
  {
    path: "/",
    element: <AuthenticatedUserFilter />,
    children: [
      // --
      {
        path: "analytics",
        element: <AnalyticsSwitch />,
      },
      {
        path: "clients",
        element: <ClientsSwitch />,
      },
      {
        path: "notifications",
        element: <NotificationsSwitch />,
      },
      {
        path: "orders",
        element: <OrdersSwitch />,
      },
      {
        path: "settings",
        element: <SettingsSwitch />,
      },
      {
        path: "settings/profile",
        element: <SettingsProfileSwitch />,
      },
      {
        path: "settings/workspace",
        element: <SettingsWorkspaceSwitch />,
      },
      /**
       *
       * START @Routes for Recruiters
       * These routes are specifically for Recruiter accounts
       */
      {
        path: "create-client",
        element: <CreateClientSwitch />,
      },
      {
        path: "create-order",
        element: <CreateOrderSwitch />,
      },
      // --
      {
        path: "clients/:clientUsername",
        element: <ClientDashboardPage />,
      },
      {
        path: "clients/:clientUsername/analytics",
        element: <ClientAnalyticsPage />,
      },
      {
        path: "clients/:clientUsername/notifications",
        element: <ClientNotificationsPage />,
      },
      {
        path: "clients/:clientUsername/orders",
        element: <ClientOrdersPage />,
      },
      {
        path: "clients/:clientUsername/settings",
        element: <ClientSettingsPage />,
      },
      {
        path: "clients/:clientUsername/create-order",
        element: <ClientCreateOrderPage />,
      },
      // ----------------------------------------------------
      {
        path: "clients/:clientUsername/orders/:orderUsername",
        element: <OrderDashboardPage />,
      },
      {
        path: "clients/:clientUsername/orders/:orderUsername/analytics",
        element: <OrderAnalyticsPage />,
      },
      {
        path: "clients/:clientUsername/orders/:orderUsername/candidate-shortlist",
        element: <OrderShortlistPage />,
      },
      {
        path: "clients/:clientUsername/orders/:orderUsername/candidate-shortlist/:candidateUsername",
        element: <OrderCandidatePage />,
      },
      {
        path: "clients/:clientUsername/orders/:orderUsername/job-posting",
        element: <OrderJobPostingPage />,
      },
      {
        path: "clients/:clientUsername/orders/:orderUsername/notifications",
        element: <OrderNotificationsPage />,
      },
      {
        path: "clients/:clientUsername/orders/:orderUsername/order-status",
        element: <OrderStatusPage />,
      },
      {
        path: "clients/:clientUsername/orders/:orderUsername/settings",
        element: <OrderSettingsPage />,
      },
      /**
       *
       * END @Routes for Recruiters
       *
       * These routes are specifically for Recruiter accounts
       *
       */
      // ----------------------------------------------------
      /**
       *
       * START @Routes for Employers
       *  These routes are specifically for private-access employers
       */
      {
        path: "orders/:orderUsername",
        element: <OrderDashboardPage />,
      },
      {
        path: "orders/:orderUsername/candidate-shortlist",
        element: <OrderShortlistPage />,
      },
      {
        path: "orders/:orderUsername/candidate-shortlist/:candidateUsername",
        element: <OrderCandidatePage />,
      },
      {
        path: "orders/:orderUsername/job-posting",
        element: <OrderJobPostingPage />,
      },
      {
        path: "orders/:orderUsername/notifications",
        element: <OrderNotificationsPage />,
      },
      {
        path: "orders/:orderUsername/order-status",
        element: <OrderStatusPage />,
      },
      {
        path: "orders/:orderUsername/settings",
        element: <OrderSettingsPage />,
      },
      /**
       *
       * END @Routes for Employers
       *  These routes are specifically for private-access employers
       */
      {
        path: "recruiters",
        element: <AdminRecruitersPage />,
      },
      // --
      /**
       *
       * START @Routes for Admins
       * Includes all the recruiters, clusters, and orders routes
       *  for admins accessing Recruiter information.
       *
       */
      {
        path: "recruiters/:recruiterUsername",
        element: <RecruiterDashboardPage />,
      },
      {
        path: "recruiters/:recruiterUsername/analytics",
        element: <RecruiterAnalyticsPage />,
      },
      {
        path: "recruiters/:recruiterUsername/clients",
        element: <RecruiterClientsPage />,
      },
      {
        path: "recruiters/:recruiterUsername/clients/:clientUsername",
        element: <ClientDashboardPage />,
      },
      {
        path: "recruiters/:recruiterUsername/clients/:clientUsername/analytics",
        element: <ClientAnalyticsPage />,
      },
      {
        path: "recruiters/:recruiterUsername/clients/:clientUsername/create-order",
        element: <ClientCreateOrderPage />,
      },
      {
        path: "recruiters/:recruiterUsername/clients/:clientUsername/notifications",
        element: <ClientNotificationsPage />,
      },
      {
        path: "recruiters/:recruiterUsername/clients/:clientUsername/orders",
        element: <ClientOrdersPage />,
      },
      {
        path: "recruiters/:recruiterUsername/clients/:clientUsername/orders/:orderUsername",
        element: <OrderDashboardPage />,
      },
      {
        path: "recruiters/:recruiterUsername/clients/:clientUsername/orders/:orderUsername/analytics",
        element: <OrderAnalyticsPage />,
      },
      {
        path: "recruiters/:recruiterUsername/clients/:clientUsername/orders/:orderUsername/candidate-shortlist",
        element: <OrderShortlistPage />,
      },
      {
        path: "recruiters/:recruiterUsername/clients/:clientUsername/orders/:orderUsername/candidate-shortlist/:candidateUsername",
        element: <OrderCandidatePage />,
      },
      {
        path: "recruiters/:recruiterUsername/clients/:clientUsername/orders/:orderUsername/job-posting",
        element: <OrderJobPostingPage />,
      },
      {
        path: "recruiters/:recruiterUsername/clients/:clientUsername/orders/:orderUsername/notifications",
        element: <OrderNotificationsPage />,
      },
      {
        path: "recruiters/:recruiterUsername/clients/:clientUsername/orders/:orderUsername/order-status",
        element: <OrderStatusPage />,
      },
      {
        path: "recruiters/:recruiterUsername/clients/:clientUsername/orders/:orderUsername/settings",
        element: <OrderSettingsPage />,
      },
      {
        path: "recruiters/:recruiterUsername/clients/:clientUsername/settings",
        element: <ClientSettingsPage />,
      },
      {
        path: "recruiters/:recruiterUsername/create-client",
        element: <RecruiterCreateClientPage />,
      },
      {
        path: "recruiters/:recruiterUsername/notifications",
        element: <RecruiterNotificationsPage />,
      },
      {
        path: "recruiters/:recruiterUsername/orders",
        element: <RecruiterOrdersPage />,
      },
      {
        path: "recruiters/:recruiterUsername/create-order",
        element: <RecruiterCreateOrderPage />,
      },
      {
        path: "recruiters/:recruiterUsername/settings",
        element: <RecruiterSettingsPage />,
      },
      {
        path: "recruiters/:recruiterUsername/settings/integrations",
        element: <RecruiterSettingsIntegrationsPage />,
      },
      {
        path: "recruiters/:recruiterUsername/settings/profile",
        element: <RecruiterSettingsProfilePage />,
      },
      {
        path: "recruiters/:recruiterUsername/settings/subscription",
        element: <RecruiterSettingsSubscriptionPage />,
      },
      {
        path: "recruiters/:recruiterUsername/settings/workspace",
        element: <RecruiterSettingsWorkspacePage />,
      },
      /**
       *
       * END @Routes for Admins
       *
       * Includes all the recruiters, clusters, and orders routes
       *  for admins accessing Recruiter information.
       *
       */
      // --
      {
        path: "settings/integrations",
        element: <RecruiterSettingsIntegrationsPage />,
      },
      {
        path: "settings/subscription",
        element: <RecruiterSettingsSubscriptionPage />,
      },
      // --
      {
        path: "support",
        element: <AdminSupportPage />,
      },
      // --
    ],
  },
  {
    path: "/",
    element: <PublicUserFilter />,
    children: [
      {
        path: "about",
        element: <AboutPage />,
      },
      {
        path: "blog",
        element: <BlogPage />,
      },
      {
        path: "community",
        element: <CommunityGroupsPage />,
      },
      {
        path: "community/@discord",
        element: <CommunityDiscordPage />,
      },
      {
        path: "community/@facebook",
        element: <CommunityFacebookPage />,
      },
      {
        path: "community/@linkedin",
        element: <CommunityLinkedinPage />,
      },
      {
        path: "contact",
        element: <ContactUsPage />,
      },
      {
        path: "legal",
        element: <LegalPage />,
      },
      {
        path: "privacy-policy",
        element: <PrivacyPolicyPage />,
      },
      {
        path: "terms-of-use",
        element: <TermsofUsePage />,
      },
      {
        path: "pricing",
        element: <PricingPage />,
      },
      {
        path: "reviews",
        element: <ReviewsPage />,
      },
      {
        path: "roadmap",
        element: <ProductRoadmapPage />,
      },
      {
        path: "suggest-feature",
        element: <SuggestFeaturePage />,
      },
      // --
      {
        path: "customer-support",
        element: <CustomerSupportPage />,
      },
      {
        path: "live-chat",
        element: <LiveChatPage />,
      },
    ],
  },
  {
    path: "/",
    element: <PublicEmployerFilter />,
    children: [
      /**
       * @Routes for Employers
       * Includes all the routes for public access for employers/prospects
       */
      {
        path: "recruiters/:recruiterUsername/employers/:clientUsername",
        element: <ClientDashboardPage />,
      },
      {
        path: "recruiters/:recruiterUsername/employers/:clientUsername/orders",
        element: <ClientOrdersPage />,
      },
      {
        path: "recruiters/:recruiterUsername/employers/:clientUsername/notifications",
        element: <ClientNotificationsPage />,
      },
      {
        path: "recruiters/:recruiterUsername/employers/:clientUsername/settings",
        element: <ClientSettingsPage />,
      },
      {
        path: "recruiters/:recruiterUsername/employers/:clientUsername/orders/:orderUsername",
        element: <OrderDashboardPage />,
      },
      {
        path: "recruiters/:recruiterUsername/employers/:clientUsername/orders/:orderUsername/order-status",
        element: <OrderStatusPage />,
      },
      {
        path: "recruiters/:recruiterUsername/employers/:clientUsername/orders/:orderUsername/candidate-shortlist",
        element: <OrderShortlistPage />,
      },
      {
        path: "recruiters/:recruiterUsername/employers/:clientUsername/orders/:orderUsername/candidate-shortlist/:candidateUsername",
        element: <OrderCandidatePage />,
      },
      {
        path: "recruiters/:recruiterUsername/employers/:clientUsername/orders/:orderUsername/job-posting",
        element: <OrderJobPostingPage />,
      },
      {
        path: "recruiters/:recruiterUsername/employers/:clientUsername/orders/:orderUsername/notifications",
        element: <OrderNotificationsPage />,
      },
      {
        path: "recruiters/:recruiterUsername/employers/:clientUsername/orders/:orderUsername/settings",
        element: <OrderSettingsPage />,
      },
    ],
  },
]);
